import React from 'react'
import { Container } from '@shared/components/container'
import { FullLogo } from '@shared/components/logo'
import { Burger } from '@shared/components/top-menu/shared/burger'
import { TopMenuLogin } from '@shared/components/top-menu/shared/login'
import { TopMenuList } from '@shared/components/top-menu/shared/menu-list'
import { Phone } from '@shared/components/top-menu/shared/phone'
import Link from 'next/link'

import { SmallButton } from '../small-button'

import { IStateProps } from './model'

import styles from './style.module.scss'

// если SHORT_APPLICATION - убираем лого, телефон и вход
export const View = ({
	onShowMobileLoginOptions,
	onOpenPopupMenu,
	EndAdornment,
	content,
	isLogoHidden,
	hideLinksList,
}: IStateProps) => {
	return (
		<header className={styles.wrap}>
			<Container className={styles.container}>
				{!isLogoHidden && (
					<Link href='/'>
						<FullLogo className={styles.logo} />
					</Link>
				)}
				{content || (
					<>
						{hideLinksList ? null : <TopMenuList className={styles.menuList} />}
						<div className={styles.controls}>
							<Phone />
							<SmallButton
								data-gtm-element='header-enter-button-click'
								className={styles.mobileLoginButton}
								onClick={onShowMobileLoginOptions}
							>
								Вход
							</SmallButton>
							{EndAdornment && (
								<div className={styles.endAdorment}>
									<EndAdornment />
								</div>
							)}
							<TopMenuLogin className={styles.login} />
							<Burger onClick={onOpenPopupMenu} active={false} className={styles.burger} />
						</div>
					</>
				)}
			</Container>
		</header>
	)
}
